import React, { useId } from 'react';
import style from './radioButton.module.scss';
import type { BaseFieldProps } from '.';
import { joinNames } from '../helpers';
import { useField } from 'formik';
import { ErrorMessage } from '../Container';
import Label from '../Label';

type RadioButtonProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & BaseFieldProps;

export default function RadioButton({ name, id, label, error, tabIndex, className, ...attr }: RadioButtonProps) {
    const errorId = `${id}error`;
    return (
        <div>
            <div className={joinNames(className, style.wrapper)}>
                <input type="radio" tabIndex={tabIndex} name={name} id={id} {...attr} />
                <Label htmlFor={id}>{label}</Label>
            </div>
            {error && <ErrorMessage id={errorId}>{error}</ErrorMessage>}
        </div>
    );
}

export function FormikRadioButton({ name, label, checked, value, id, ...attr }: Omit<RadioButtonProps, 'onBlur' | 'onChange'>): JSX.Element {
    id = useId();
    const [props, { touched, error }] = useField({
        name,
        type: 'radio',
        value,
        checked,
    });
    return <RadioButton error={touched && error} id={id} label={label} {...props} {...attr} />;
}
